<template>
  <cly-dropdown
    ref="userDropdown"
    placement="bottom-end"
    class="cursor-pointer"
  >
    <template #trigger>
      <cly-avatar
        class="header-user-avatar"
        :is-google-user="isGoogleUser"
        :name="accountCurrent.firstName + ' ' + accountCurrent.lastName"
        :src="accountCurrent.picture"
        size="xsmall"
        no-shadow
        circle
        bordered
      />
    </template>
    <div
      style="border-radius: 12px; overflow: hidden; width: 280px;"
      class="shadow-md bg-white"
    >
      <div style="padding: 12px 16px; border-bottom: 1px solid #f5f5f5;">
        <div
          class="flex items-center"
          style="gap: 8px;"
        >
          <div style="font-size: 12px; font-weight: 500; color: #171717;">
            {{ accountCurrent.firstName }} {{ accountCurrent.lastName }}
          </div>
        </div>
        <div style="font-size: 11px; color: #737373; margin-top: 2px;">
          {{ accountCurrent.email }}
        </div>
      </div>
      <div>
        <div
          v-for="(group, groupIndex) in userMenuGroups"
          :key="groupIndex"
          :style="groupIndex > 0 ? 'border-top: 1px solid #f5f5f5;' : ''"
          style="padding: 4px 0;"
        >
          <div
            v-for="(item, index) in group"
            :key="index"
            class="cursor-pointer hover:bg-cool-gray-10"
            style="padding: 8px 16px; font-size: 12px; color: #171717;"
            @click="item.handler"
          >
            {{ $t(item.label) }}
          </div>
        </div>
      </div>
    </div>
  </cly-dropdown>
</template>

<script>
import { storeToRefs, mapActions } from 'pinia';
import { useAuthStore } from '@/stores';
import { SignUpSource } from '@/modules/user/IUser';

export default {
  name: 'UserMenuDropdown',
  setup() {
    const authStore = useAuthStore();
    const { loggedInUser } = storeToRefs(authStore);
    return { loggedInUser };
  },
  data() {
    return {
      userMenuGroups: [
        [
          {
            label: 'mycountly.menu.account-settings',
            handler: () => this.goToSettings('accountSettings'),
          },
        ],
        [
          {
            label: 'mycountly.menu.workspace-settings',
            handler: () => this.goToSettings('workspaceSettings'),
          },
          {
            label: 'mycountly.menu.team',
            handler: () => this.goToSettings('teamSettings'),
          },
          {
            label: 'mycountly.menu.billing',
            handler: () => this.goToSettings('billingSettings'),
          },
        ],
        [
          {
            label: 'mycountly.menu.logout',
            handler: () => this.signout(),
          },
        ],
      ],
    };
  },
  computed: {
    isGoogleUser() {
      return this.loggedInUser && this.loggedInUser.via === SignUpSource.GOOGLE;
    },
    accountCurrent() {
      if (!this.loggedInUser) {
        return {};
      }
      return {
        firstName: this.loggedInUser.firstName,
        lastName: this.loggedInUser.lastName,
        designation: this.loggedInUser.designation,
        picture: this.loggedInUser.picture,
        email: this.loggedInUser.email,
        via: this.loggedInUser.via,
      };
    },
  },
  methods: {
    ...mapActions(useAuthStore, ['submitSignOut']),
    goToSettings(routeName) {
      this.$refs.userDropdown.doClose();
      this.$router.push({
        name: routeName,
        params: this.$route.params,
      }).catch(() => {});
    },
    async signout() {
      await this.submitSignOut();
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.header-user-avatar ::v-deep .cly-avatar__inner {
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
}
</style>
